<template>
    <div class="affirmCom">
		<div class="titleBox">
			<span class="titleText">救援现场环境照</span>
            <van-icon name="cross" size="20" class="closeIcon" @click="affirm(1)"/>
		</div>
		<div class="tips">
			<span class="tipsText">为了提高现场救援效率，请您协助拍摄现场救援环境!</span>
		</div>
        <div class="uploadSiteImgs">
            <div class="tipText">示例图</div>
            <van-uploader 
                upload-text='现场照片'
                result-type='file'
                :max-count="4"
                :after-read="siteAfterRead"
                :before-delete='delSiteImage'
                v-model="sitePhotos"/>
        </div>
		<div class="affirmBtn">
			<span class="affirmText" @click="affirm(2)">确 认</span>
		</div>
    </div>
</template>

<script>
import { putOSS } from '@/utils/uploadOSS';
import { uploadPicture } from '@/apis/checkList';
export default {
    props: {
        order: {
            type: String,
            default: ''
        },
        order_id: {
            type: String | Number,
            default: ''
        },
    },
    data(){
        return {
            sitePhotos: [
                {
                    id: '', 
                    url: require('@/assets/order/siteTipImg.png'),
                    deletable: false
                }
            ]
        }
    },
    methods: {
        affirm(e){
            if(this.sitePhotos.length == 1){
                this.$toast('请上传救援现场照片！');
                return
            }
            let sitePhotos = JSON.parse(JSON.stringify(this.sitePhotos))
            sitePhotos.shift()
            this.$emit('affirm', sitePhotos)
        },
        // 上传现场照片
        async siteAfterRead(file){
            console.log(file, 'file')
            let that = this
            if(Array.isArray(file)){
                // 数组 多张
                file.forEach((e, index)=>{
                    e.status = 'uploading';
                    e.message = '上传中...';
                    putOSS(e.file, that.order_id).then((url)=>{
                        let data = {
                            order: this.order,
                            photo: url
                        }
                        uploadPicture(data).then((res)=>{
                            console.log(res, '上传现场照片');
                            e.status = 'done';
                            e.message = '上传成功';
                            e.id = res.data.data.picture_id;
                            e.url = url;
                        }).catch(()=>{
                            e.status = 'failed';
                            e.message = '上传失败';
                        })
                    })
                });
            }else{
                // 对象
                file.status = 'uploading';
                file.message = '上传中...';
                putOSS(file.file, that.order_id).then((url)=>{
                    let data = {
                        order: this.order,
                        photo: url
                    }
                    uploadPicture(data).then((res)=>{
                        console.log(res, '上传现场照片');
                        file.status = 'done';
                        file.message = '上传成功';
                        file.id = res.data.data.picture_id;
                        file.url = url;
                    }).catch(()=>{
                        file.status = 'failed';
                        file.message = '上传失败';
                    })
                })
            }
        },
        // 删除现场照片
        delSiteImage(file, detail){
            if(file.id){
                let data = {
                    order: this.order,
                    picture_id: file.id
                }
                uploadPicture(data).then((res)=>{
                    if(res.data.code == 1){
                        this.sitePhotos.splice(detail.index, 1);
                        return true;
                    }else{
                        this.$toast(res.data.info);
                    }
                })
            }else{
                return false;
            }
        },
    }
}
</script>

<style lang='scss'>
    .uploadSiteImgs{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        position: relative;
        .van-uploader__preview, .van-uploader__upload {
            width: 125px;
            height: 94px;
            .van-image{
                width: 125px;
                height: 94px;
            }
        }
        .van-uploader{
            width: 100%;
        }
        .van-uploader__wrapper{
            justify-content: space-between;
        }
        .tipText{
            z-index: 999;
            position: absolute;
            top: 0;
            left: 0;
            display: inline-block;
            width: 40px;
            height: 16px;
            background: var(--theme-color);
            opacity: 1;
            border-radius: 4px 0px 4px 0px;
            font-size: 10px;
            font-family: PingFangSC-Medium;
            color: var(--theme-btn);
            text-align: center;
            line-height: 16px;
        }
    }
</style>

<style lang="scss" scoped>
    .affirmCom{
        padding: 0 16px 20px;
        .closeIcon{
            position: absolute;
            top: 10px;
            right: 10px;
        }
		.titleBox{
		    height: 44px;
		    margin-bottom: 5px;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			.titleText{
				font-size: 16px;
				font-weight: bold;
			}
		}
		.tips{
			margin-bottom: 12px;
			.tipsText{
				font-size: 14px;
				color: #F01C1C;
			}
		}
        .affirmBtn{
			height: 40px;
			background: var(--theme-color);
			border-radius: 50px;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			margin-top: 25px;
			.affirmText{
				font-weight: 600;
				font-size: 15px;
				color: var(--theme-btn);
			}
		}
    }
</style>